import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Profesora Mariana Gómez',
  location: 'Córdoba',
  text: 'Me ahorra una cantidad enorme de tiempo. Los ejemplos de código y las diapositivas ya están listas y las actividades son mucho más dinámicas que las que usaba antes.',
  img: 'https://randomuser.me/api/portraits/women/44.jpg'
}, {
  name: 'Profesor Lucas Fernández',
  location: 'Buenos Aires',
  text: 'Antes pasaba noches enteras armando clases de programación. Ahora tengo todo organizado y puedo enfocarme mucho más en enseñar lógica.',
  img: 'https://randomuser.me/api/portraits/men/32.jpg'
}, {
  name: 'Profesora Carla Benítez',
  location: 'Rosario',
  text: 'El material está súper completo. Los proyectos prácticos y las evaluaciones me resolvieron muchísimo tiempo de planificación.',
  img: 'https://randomuser.me/api/portraits/women/68.jpg'
}, {
  name: 'Profesora Valeria Acosta',
  location: 'Mendoza',
  text: 'Mis clases cambiaron completamente. Los alumnos participan más y yo ya no tengo que improvisar algoritmos ni buscar ejercicios a último momento.',
  img: 'https://randomuser.me/api/portraits/women/22.jpg'
}, {
  name: 'Profesora Silvia Martínez',
  location: 'Salta',
  text: 'Una inversión excelente. La calidad de los diagramas de flujo y recursos visuales es de primer nivel. Mis alumnos lo notaron enseguida.',
  img: 'https://randomuser.me/api/portraits/women/55.jpg'
}, {
  name: 'Profesora Andrea López',
  location: 'Neuquén',
  text: 'Lo que más valoro son las planificaciones ya armadas. Me sacó un peso enorme de encima para presentar en la escuela.',
  img: 'https://randomuser.me/api/portraits/women/33.jpg'
}, {
  name: 'Profesora Romina Castro',
  location: 'Tucumán',
  text: 'Doy clases en 4 universidades distintas y esto me salvó la vida. Entro al aula, abro el material y ya sé exactamente qué dar.',
  img: 'https://randomuser.me/api/portraits/women/12.jpg'
}, {
  name: 'Profesor Martín Herrera',
  location: 'Santa Fe',
  text: 'No es solo teoría, los retos de código son realmente didácticos y pensados para los chicos de hoy. Lo recomiendo 100%.',
  img: 'https://randomuser.me/api/portraits/men/46.jpg'
}];
export function Testimonials() {
  return <section className="py-8 md:py-16 px-4 bg-dark-900 border-t border-dark-800" data-id="element-164">
      <div className="max-w-6xl mx-auto" data-id="element-165">
        <div className="text-center mb-8 md:mb-12" data-id="element-166">
          <h2 className="text-2xl md:text-5xl font-black text-white mb-3 md:mb-4 uppercase" data-id="element-167">
            💬 LO QUE DICEN OTROS{' '}
            <span className="text-brand-400" data-id="element-168">DOCENTES</span>
          </h2>
          <p className="text-base md:text-xl text-gray-400 font-medium" data-id="element-169">
            Docentes de todo el país ya están ahorrando horas de planificación.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6" data-id="element-170">
          {testimonials.map((t, i) => <div key={i} className="bg-dark-800 p-5 md:p-6 rounded-2xl shadow-md border border-dark-700 flex flex-col h-full" data-id="element-171">
              <div className="flex items-center gap-1 text-yellow-400 mb-3 md:mb-4" data-id="element-172">
                {[...Array(5)].map((_, j) => <Star key={j} size={14} className="md:w-4 md:h-4" fill="currentColor" data-id="element-173" />)}
              </div>
              <p className="text-sm md:text-base text-gray-300 font-medium italic mb-4 md:mb-6 flex-grow" data-id="element-174">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3 mt-auto pt-3 md:pt-4 border-t border-dark-700" data-id="element-175">
                <img src={t.img} alt={t.name} className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover" data-id="element-176" />
                <div data-id="element-177">
                  <p className="font-bold text-xs md:text-sm text-gray-200" data-id="element-178">
                    {t.name}
                  </p>
                  <p className="text-[10px] md:text-xs text-gray-500" data-id="element-179">
                    {t.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-10 md:mt-16 text-center max-w-3xl mx-auto" data-id="element-180">
          <h3 className="text-xl md:text-4xl font-black text-white mb-4 md:mb-6" data-id="element-181">
            Este sistema fue creado para docentes reales, con tiempos reales y
            necesidades reales.
          </h3>
          <p className="text-lg md:text-2xl font-bold text-brand-400 mb-6 md:mb-10" data-id="element-182">
            No reemplaza tu trabajo.{' '}
            <span className="text-brand-300 uppercase" data-id="element-183">Lo potencia.</span>
          </p>
        </div>
      </div>
    </section>;
}